import type { TAppState } from '../../types/appState';
import type { IChatProfile } from '../../types/chatProfile';

export const userProfileByChatIdSelector = (state: TAppState, chatId: string): IChatProfile | null => {
  return state.userProfile[chatId] ?? null;
};
